<template lang="pug">
  v-card.sidebar__menu(
    :elevated="elevated")
    template(v-for="item in items")
      .sidebar__menu-item(
        :class="{ 'sidebar__menu-item--active': isActive(item) }"
        @click="onItemClick(item)")
        span {{ item.title | translate }}
</template>

<script>
export default {
  name: 'HistoryMenu',

  props: {
    elevated: Boolean
  },

  data: () => ({
    items: [
      { id: 0, title: 'sidebar.farms', path: 'history/farms' },
      { id: 1, title: 'sidebar.rations', path: 'history/ration' },
      { id: 2, title: 'sidebar.groups', path: 'history/groups' },
      { id: 3, title: 'sidebar.animal_types', path: 'history/animal-types' },
      { id: 4, title: 'sidebar.ingredients', path: 'history/ingredients' },
      { id: 5, title: 'sidebar.ingredient_types', path: 'history/ingredient-types' },
      { id: 6, title: 'sidebar.mixers', path: 'history/mixers' },
      { id: 7, title: 'sidebar.stocks', path: 'history/stocks' }
    ]
  }),

  methods: {
    isActive (item) {
      return this.$route.path
        .includes(item.path)
    },

    onItemClick (item) {
      this.$router.push(`../${item.path}`)
    }
  }
}
</script>
